/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolGestureIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-gesture"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M14.03 21.8Q12.55 21.8 11.5 20.74Q10.45 19.68 10.45 18.2Q10.45 16.1 12.05 14.4Q13.65 12.7 16.05 12.28Q15.97 11.47 15.66 11.13Q15.35 10.78 14.75 10.78Q13.95 10.78 13.1 11.41Q12.25 12.05 10.88 13.72Q9.13 15.93 7.99 16.75Q6.85 17.57 5.53 17.57Q4.08 17.57 3.15 16.6Q2.23 15.63 2.23 14.13Q2.23 12.95 2.84 11.54Q3.45 10.13 4.88 8Q5.6 6.95 5.89 6.45Q6.17 5.95 6.17 5.67Q6.17 5.53 6.1 5.44Q6.03 5.35 5.9 5.35Q5.8 5.35 5.67 5.41Q5.55 5.47 5.4 5.63Q4.95 6.05 4.34 6.09Q3.73 6.13 3.3 5.7Q2.8 5.2 2.76 4.53Q2.73 3.85 3.23 3.42Q3.88 2.85 4.63 2.52Q5.38 2.2 6.13 2.2Q7.4 2.2 8.35 3.16Q9.3 4.13 9.3 5.42Q9.3 6.3 8.78 7.44Q8.25 8.57 7.03 10.32Q6.13 11.68 5.74 12.47Q5.35 13.28 5.35 13.78Q5.35 14.05 5.49 14.24Q5.63 14.43 5.83 14.43Q6.03 14.43 6.19 14.31Q6.35 14.2 6.72 13.78Q7 13.5 7.38 13.03Q7.75 12.55 8.32 11.85Q10.2 9.55 11.7 8.59Q13.2 7.63 14.78 7.63Q16.63 7.63 17.81 8.82Q19 10.03 19.2 12.1L20.23 12.1Q20.88 12.1 21.34 12.56Q21.8 13.03 21.8 13.68Q21.8 14.32 21.34 14.79Q20.88 15.25 20.23 15.25L19.2 15.25Q18.98 18.2 17.55 20Q16.13 21.8 14.03 21.8ZM14.13 18.65Q14.72 18.65 15.24 17.8Q15.75 16.95 16.05 15.43Q15.05 15.72 14.31 16.5Q13.57 17.27 13.57 18.02Q13.57 18.32 13.71 18.49Q13.85 18.65 14.13 18.65Z" fill={color} />
    </svg>
  );
}
